require('./../../assets/sass/main.scss');
require('./../../node_modules/@visit-x/vxmessenger/vxm_build/styles.css');
import * as React from "react";
import App from "./App";
import { createRoot } from 'react-dom/client';
function runApp() {
  var container = document.getElementById('reactroot');
  var root = createRoot(container);
  root.render(/*#__PURE__*/React.createElement(App, null));
}
if (!global.Intl) {
  // @ts-ignore
  require.ensure(['intl', 'intl/locale-data/jsonp/de.js', 'intl/locale-data/jsonp/de-CH.js', 'intl/locale-data/jsonp/de-AT.js'], function (require) {
    require('intl');
    require('intl/locale-data/jsonp/de.js');
    require('intl/locale-data/jsonp/de-CH.js');
    require('intl/locale-data/jsonp/de-AT.js');
    runApp();
  });
} else {
  runApp();
}